@if(isAdmin || isDepartmentAdmin){
  <mat-snack-bar-container></mat-snack-bar-container>
  <div class="container">
    <div class="mat-elevation-z8">
      <form [formGroup]="activityFormGroup" (ngSubmit)="onSaveCategory()" class="user-form">
        <h2>Activities</h2>
        
        <div class="form-row">
          <div class="field">
            <mat-form-field appearance="outline">
              <mat-label>Activity Name</mat-label>
              <input matInput formControlName="name" required>
              <mat-error *ngIf="activityFormGroup.get('name')?.invalid && activityFormGroup.get('name')?.touched">
                Activity Name is required
              </mat-error>
            </mat-form-field>
          </div>
          
          <div class="field">
            <mat-form-field appearance="outline">
              <mat-label>Category Type</mat-label>
              <mat-select formControlName="categoryTypeId" required>
                <mat-option *ngFor="let activity of typeList" [value]="activity.id">{{ activity.type }}</mat-option>
              </mat-select>
              <mat-error *ngIf="activityFormGroup.get('categoryTypeId')?.invalid && activityFormGroup.get('categoryTypeId')?.touched">
                Category Type is required
              </mat-error>
            </mat-form-field>
          </div>

          <div class="field">
            <mat-form-field appearance="outline">
              <mat-label>Department</mat-label>
              <mat-select formControlName="departmentId" required>
                <mat-option *ngFor="let department of departments" [value]="department.id">{{ department.departmentName }}</mat-option>
              </mat-select>
              <mat-error *ngIf="activityFormGroup.get('departmentId')?.invalid && activityFormGroup.get('departmentId')?.touched">
                Department is required
              </mat-error>
            </mat-form-field>
          </div>

          <button mat-raised-button color="primary" type="submit" >Submit</button>
        </div> <!-- end of form-row -->
        
        <div *ngIf="isSubmitting" class="loading">
          <mat-spinner diameter="30"></mat-spinner>
          <span>Submitting...</span>
        </div>
      </form>
      <app-activity-list></app-activity-list>
    </div>
  </div>
} @else {
  <p>you are not authorized.</p>
}